<div class="popup" tabindex="-1" role="dialog" [ngClass]="isOpen ? 'open' : ''">
  <a (click)="close()"></a>

  <div class="popup-content">
    <h5 class="d-flex align-items-center">
      Support und Feedback

      <button type="button" class="btn-close" style="margin-left: auto" aria-label="Close" (click)="close()"></button>
    </h5>

    <div class="mb-4 d-flex flex-column justify-content-center">
      <textarea #supportMessageTextarea name="support-message" placeholder="Ihre Nachricht"
        i18n-placeholder="@@SupportMessagePlaceholder" form-control-name="support-message" class="w-100 text-dark p-2"
        rows="8" cols="160" (input)="onValueChange($event)"></textarea>
    </div>

    <div style="display: flex; gap: .5rem; justify-content:space-between">
      <button type="button" class="btn btn-default" (click)="close()"
        i18n="@@TransactionCloseBtnText">Abbrechen</button>

      <button type="button" class="btn btn-save float-end pull-right" (click)="send()" i18n="@@TransactionCloseBtnText"
        [disabled]="isSending">
        <span *ngIf="!isSending">Absenden</span>
        <span *ngIf="isSending">Sende...</span>
      </button>
    </div>
  </div>
</div>